import styled from "styled-components/native";

export default styled.ScrollView.attrs({
  horizontal: true,
  showsHorizontalScrollIndicator: false,
})`
  margin-top: 8px;
  width: 100%;
`;
